import apiClient from '../client';
import type { User, CreateUserPayload, UpdateUserPayload } from '@/types';

export const usersApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: User[] }>('/users', { params }).then((r) => r.data.data),

  getById: (id: number) =>
    apiClient.get<{ data: User }>(`/users/${id}`).then((r) => r.data.data),

  create: (payload: CreateUserPayload) =>
    apiClient.post<{ data: User }>('/users', payload).then((r) => r.data.data),

  update: (id: number, payload: UpdateUserPayload) =>
    apiClient.put<{ data: User }>(`/users/${id}`, payload).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`/users/${id}`),
};

